import React, { PureComponent } from "react";
import Select from "../../Select";
import venueOptions from "../../../constants/venueOptions";
import FilterGroup from "../FilterGroup";

class VenueFilter extends PureComponent {
  render() {
    const { name, onChangeHandler, value, ...rest } = this.props;

    return (
      <FilterGroup title="Venue Selection">
        <Select
          name={name}
          {...rest}
          value={value}
          onChange={onChangeHandler}
          options={venueOptions}
        />
      </FilterGroup>
    );
  }
}

export default VenueFilter;



// WEBPACK FOOTER //
// ./src/components/filters/options/VenueFilter.js